<script>
import { MapAgentStationStatus, MapRefundStatus } from "@/common/util";
import basicLineChart from "@/components/visionStatistics/basicLineChart.vue";
import sortBy from "lodash/sortBy";
import cloneDeep from "lodash/cloneDeep";
import forOwn from "lodash/forOwn";
import moment from "moment";
export default {
  components: {
    basicLineChart
  },
  data() {
    const defaultDate = [
      moment()
        .subtract(1, "months")
        .format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD")
    ];
    return {
      typeSource: [
        {
          name: "精细刺激训练",
          type: "FINE_STIMULATION_TRAINING"
        },
        {
          name: "视觉技巧训练",
          type: "VISUAL_SKILL_TRAINING"
        },
        {
          name: "同时视",
          type: "SAME_TIME_BINOCULAR_VISION_TRAINING"
        },
        {
          name: "融合视",
          type: "FUSION_VISION_BINOCULAR_VISION_TRAINING"
        },
        {
          name: "立体视",
          type: "STEREOSCOPIC_BINOCULAR_VISION_TRAINING"
        },
        {
          name: "Gabor训练",
          type: "GABOR_TRAINING"
        },
        {
          name: "对比敏感度训练",
          type: "CONTRAST_SENSITIVITY_TRAINING"
        },
        {
          name: "信息提取训练",
          type: "INFORMATION_EXTRACTION_TRAINING"
        }
      ],
      type: "FINE_STIMULATION_TRAINING",
      games: [],
      gameId: undefined,
      gameLevel: 1,
      gameMaxLevel: 5,
      searchFormData: {
        name: undefined,
        phone: undefined,
        agent: undefined,
        station: undefined,
        provinceCity: undefined,
        age: undefined
      },
      patientAge: 5,
      tableData: [],
      SearchArray: [
        {
          label: "年龄选择：",
          keyName: "age",
          type: "text"
        },
        {
          label: "时段选择：",
          keyName: "dateRange",
          type: "dateRange"
        }
      ],
      ageArray: [
        {
          name: "4岁",
          key: 4
        },
        {
          name: "5岁",
          key: 5
        },
        {
          name: "6岁",
          key: 6
        },
        {
          name: "7岁",
          key: 7
        },
        {
          name: "8岁",
          key: 8
        },
        {
          name: "9岁",
          key: 9
        },
        {
          name: "10岁",
          key: 10
        },
        {
          name: "11岁",
          key: 11
        },
        {
          name: "12岁",
          key: 12
        },
        {
          name: "13岁",
          key: 13
        },
        {
          name: "14岁",
          key: 14
        },
        {
          name: "15岁",
          key: 15
        },
        {
          name: "16岁",
          key: 16
        },
        {
          name: "17岁",
          key: 17
        },
        {
          name: "18岁",
          key: 18
        }
      ],
      refundPass: false,
      refundRject: false,
      defaultValue: {},
      agentList: [],
      pageCount: 0,
      activePage: 1,
      totalElements: 1,
      dateRange: defaultDate,
      chartArray: [],
      passTime: {},
      needRefresh: true
    };
  },
  //   computed: {
  //     activeSearchArray() {
  //       return this.SearchArray;
  //     }
  //   },
  created() {
    this.loadData();
    this.$nextTick(() => {
      document.addEventListener("keyup", this.onEnterForSearch);
    });
  },
  destroyed() {
    document.removeEventListener("keyup", this.onEnterForSearch);
  },
  methods: {
    async loadData() {
      const result = await this.$http.getGameList(this.type);
      this.games = result.data ? result.data.content : [];
      if (this.games.length) {
        let activeGame = this.games[0];
        let activeGameLevel = 1;
        const gameLevel = activeGameLevel;
        this.gameId = activeGame.id;
        let gameMaxLevel = [];
        for (let i = 1; i <= activeGame.totalLevel; i++) {
          gameMaxLevel.push({
            name: `关卡${i}`,
            key: i
          });
        }
        this.gameMaxLevel = gameMaxLevel;
        this.gameLevel = gameLevel;
      }
    },
    onSelectGame(gameId) {
      if (gameId) {
        this.gameLevel = 1;
      }
    },
    onSelectGameType(type) {
      if (type) {
        this.gameId = undefined;
        this.games = [];
        this.gameLevel = 1;
        this.gameMaxLevel = [];
        this.loadData();
      }
    },
    onSearch() {
      this.loadStatistic();
    },
    async loadStatistic() {
      const params = {
        gameId: this.gameId,
        level: this.gameLevel,
        start: this.dateRange[0] ? this.dateRange[0] : undefined,
        end: this.dateRange[1] ? this.dateRange[1] : undefined,
        age: this.patientAge ? this.patientAge : undefined,
        size: 5000,
        sort: "createdAt"
      };
      const result = await this.$http.gameTrainStatistic(params);
      const sortResult = sortBy(result, "createdAt");
      console.log("tresult", sortResult);
      const mapResult = {};
      if (result.length > 0) {
        sortResult.forEach(item => {
          if (item.data) {
            for (let propName in item.data) {
              if (mapResult[propName]) {
                mapResult[propName].StatisticsResult.push({
                  createdAt: item.createdAt,
                  value: item.data[propName] || ""
                });
              } else {
                mapResult[propName] = {
                  yType: propName,
                  chartTitle: `${propName}统计情况`,
                  chartYTitle: undefined,
                  seriesNameY: propName,
                  StatisticsResult: [
                    {
                      createdAt: item.createdAt,
                      value: item.data[propName] || ""
                    }
                  ]
                };
              }
            }
          } else {
            for (let obj in mapResult) {
              mapResult[obj].StatisticsResult.push({
                createdAt: item.createdAt,
                value: ""
              });
            }
          }
        });
        const chartArray = [];
        const mustValue = ["闯关时间", "闯关成功次数", "闯关失败次数"];
        for (let i in mustValue) {
          chartArray.push(mapResult[mustValue[i]]);
        }
        const tempArray = [];
        for (let obj in mapResult) {
          if (mustValue.indexOf(obj) === -1) {
            chartArray.push(mapResult[obj]);
          }
        }
        this.chartArray = chartArray;
        console.log("this.chartArray->>>0", mapResult);
      }
      this.needRefresh = false;
      this.$nextTick(() => {
        this.needRefresh = true;
      });
    },
    onSelectValue(refName, value) {
      if (value === false) {
        this.$refs[refName].blur();
      }
    },
    onEnterForSearch(e) {
      if (e.key == "Enter") {
        this.loadStatistic();
      }
    }
  }
};
</script>
<template>
  <div class="StatisticsGroupOptometrist">
    <el-row :gutter="24" class="gameSearchForm">
      <el-col :span="8" class="colStyle">
        <span class="searchTitle">训练类别：</span>
        <span>
          <el-select
            size="medium"
            v-model="type"
            @change="onSelectGameType"
            @visible-change="(value) => onSelectValue('type', value)"
            class="selectInputStyle"
            ref="type"
          >
            <el-option
              v-for="typeInfo in typeSource"
              :key="typeInfo.type + typeInfo.name"
              :label="typeInfo.name"
              :value="typeInfo.type"
            />
          </el-select>
        </span>
      </el-col>
      <el-col :span="8" class="colStyle">
        <span class="searchTitle">选择游戏：</span>
        <span>
          <el-select
            size="medium"
            v-model="gameId"
            @change="onSelectGame"
            @visible-change="(value) => onSelectValue('gameId', value)"
            class="selectInputStyle"
            filterable
            ref="gameId"
            v-if="games && games.length > 0"
          >
            <el-option
              v-for="(game, index) in games"
              :key="index + '_gameName'"
              :label="game.name"
              :value="game.id"
            />
          </el-select>
        </span>
      </el-col>
      <el-col :span="8" class="colStyle">
        <span class="searchTitle">选择关卡：</span>
        <span>
          <el-select
            size="medium"
            v-model="gameLevel"
            @visible-change="(value) => onSelectValue('gameLevel', value)"
            ref="gameLevel"
            class="selectInputStyle"
            v-if="gameMaxLevel && gameMaxLevel.length > 0"
          >
            <el-option
              v-for="(item, index) in gameMaxLevel"
              :key="index + 'gameLevel'"
              :label="item.name"
              :value="item.key"
            />
          </el-select>
        </span>
      </el-col>
    </el-row>
    <el-row :gutter="24" class="gameSearchForm">
      <el-col :span="8" class="colStyle">
        <span class="searchTitle">年龄选择：</span>
        <span>
          <el-select
            size="medium"
            ref="patientAge"
            placeholder="请选择患者年龄"
            v-model="patientAge"
            class="selectInputStyle"
            @visible-change="(value) => onSelectValue('patientAge', value)"
          >
            <el-option
              v-for="(item, index) in ageArray"
              :key="index + 'patientAge'"
              :label="item.name"
              :value="item.key"
            />
          </el-select>
        </span>
      </el-col>
      <el-col :span="12" class="colStyle">
        <span class="searchTitle">时段选择：</span>
        <span>
          <el-date-picker
            v-model="dateRange"
            size="medium"
            class="dateRange"
            type="daterange"
            range-separator="-"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </span>
      </el-col>
      <el-col :span="4" class="colStyle">
        <el-button class="searchButton" size="medium" @click="onSearch">搜索</el-button>
      </el-col>
    </el-row>

    <div class="chartview" v-if="needRefresh && chartArray.length > 0">
      <basicLineChart
        v-for="(item ,index) in chartArray"
        class="statisticsCharts"
        :key="item.yType + index"
        :StatisticsResult="item.StatisticsResult"
        :chartTitle="item.chartTitle"
        :chartYTitle="item.chartYTitle"
        :yType="item.yType"
        :seriesNameY="item.seriesNameY"
      />
    </div>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.StatisticsGroupOptometrist {
  padding-left: 30px;
  padding-top: 15px;
  .gameSearchForm {
    margin: 0px 0px 10px !important;
    color: rgba(89, 94, 122, 1);
    width: 760px;
    .colStyle {
      padding: 0 !important;
    }
    .selectInputStyle {
      width: 150px;
    }
    .searchTitle {
      padding-right: 10px;
      display: inline-block;
    }
    .dateRange {
      width: 250px;

      .el-range-editor--mini.el-input__inner {
        height: 32px;
      }

      .el-range-editor.is-active,
      .el-range-editor.is-active:hover {
        border-color: #00c1de;
      }

      .el-date-table td.today span {
        color: #00c1de;
      }
    }
    .searchButton {
      background-color: #00c1de;
      border-color: #00c1de;
      color: #fff;
      height: 36px;
    }
  }
  .chartview {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    .statisticsCharts {
      margin-bottom: 15px;
      margin-top: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/visionStatistics/StatisticsGroupOptometrist.vue